import { SAVE_USER, REMOVE_USER } from '../actions/actionTypes';

import User from '../../models/User';

export const initialUserState: User = {
  email: '',
  firstName: '',
  forwarder_id: 0,
  lastName: '',
  org: '',
  orgAddress: '',
  role: '',
  terms_and_conditions_agreed: false,
  roleId: 0,
  roleName: '',
  tel: '',
  custom_password: undefined
};

export default function userReducer(state: User = initialUserState, action: any) {

  switch (action.type) {
      
    case SAVE_USER:
      return  { ...action.data };
    case REMOVE_USER:
      return  initialUserState;
    default:
      return state;
  }
};